const dev = {
	// API_ENDPOINT_URL: 'http://localhost:8000/api',
	API_ENDPOINT_URL: 'https://api.spka.swefss.com/api',
	// API_BASE_URL: 'http://localhost:8000'
	API_BASE_URL: 'https://api.spka.swefss.com'
};

const prod = {
	// API_ENDPOINT_URL: 'http://localhost:8000/api',
	API_ENDPOINT_URL: 'https://api.spka.swefss.com/api',
	// API_BASE_URL: 'http://localhost:8000'
	API_BASE_URL: 'https://api.spka.swefss.com'
	
};

const test = {
	// API_ENDPOINT_URL: 'http://localhost:8000/api',
	API_ENDPOINT_URL: 'https://api.spka.swefss.com/api',
	// API_BASE_URL: 'http://localhost:8000'
	API_BASE_URL: 'https://api.spka.swefss.com'
};

const getEnv = () => {
	switch (process.env.NODE_ENV) {
		case 'development':
			return dev
		case 'production':
			return prod
		case 'test':
			return test
		default:
			break;
	}
}

export const env = getEnv()
